import React from 'react';
import ProductRoutes from './product.routes';
import MainLayout from 'components/layouts/MainLayout';

const Admin = () => {
    return (
        <MainLayout>
            <ProductRoutes />
        </MainLayout>
    );
};

export default Admin;